import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tag hinzufügen")
const _hoisted_2 = { class: "w-full h-full flex flex-col items-center max-h-screen px-4 pt-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Tag")
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "w-full h-auto flex flex-col my-3" }

import { useCompany } from '@/store/company'
import { useCurrentUser } from '@/store/currentUser'
import { useSelectedProject } from '@/store/selectedProject'
import { useType } from '@/store/type'
import { alertController } from '@ionic/core'
import { 
  IonContent, 
  IonHeader, 
  IonPage, 
  IonToolbar, 
  IonButtons, 
  IonTitle,
  IonBackButton,
  modalController,
  IonLabel,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonList
} from '@ionic/vue';
import { computed } from '@vue/reactivity'
import axios from 'axios'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTagModal',
  setup(__props) {

const selectedProjectStore = useSelectedProject()
const companyStore = useCompany()
const typeStore = useType()
const currentUserStore = useCurrentUser()

const tagIdToSave = ref("")

async function dismiss() {
  await modalController.dismiss()
}

async function addTagToProject() {
  try {
    const tagIsAlreadySaved = selectedProjectStore.project.tags.findIndex(tag => tag._id === tagIdToSave.value)    
    if(tagIsAlreadySaved !== -1) 
      return await dismiss()

    await axios.post(process.env.VUE_APP_PROJECT_API_BASE_URL + 'project/' + selectedProjectStore.project._id + '/tag/' + tagIdToSave.value + "/?company=" + companyStore.activeCompany.id.toString() + '&updated_by=' + currentUserStore.currentUser.user.id, {}, {
      headers: {
        'Authorization': 'Bearer ' + currentUserStore.jwtKey
      }
    })

    const foundTag = typeStore.tagTypes.find(tag => tag._id === tagIdToSave.value)
    if(foundTag)
      selectedProjectStore.project.tags.push(foundTag)
    await dismiss()
  } catch (e) {
    console.error(e)
    const alert = await alertController.create({
      message: "Fehlgeschlagen das Tag hinzuzufügen",
      buttons: ['OK']
    })
    await alert.present()
  }
}

const tagTypesForThisProjectType = computed(() => {
  return typeStore.tagTypes.filter(tagType => {
    if(tagType.type)
      return tagType.type === selectedProjectStore.project.type
    return true
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    text: "",
                    style: {"--color":"#444444"},
                    "default-Href": "/",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dismiss()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(IonList), { class: "h-0 flex-grow w-full overflow-y-auto pt-0" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), { class: "bg-zewotherm-lightgrey" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      "cancel-text": "Abbrechen",
                      modelValue: tagIdToSave.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tagIdToSave).value = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagTypesForThisProjectType), (tag) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            key: tag._id,
                            value: tag._id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_4, _toDisplayString(tag.type ? '·' : ''), 1),
                              _createTextVNode(" " + _toDisplayString(tag.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addTagToProject())),
                style: _normalizeStyle('background-color: ' + _unref(companyStore).activeCompany.color),
                class: "w-full h-10 text-white font-bold rounded-lg translate cursor-pointer flex justify-center items-center active:scale-95 duration-200"
              }, " Speichern ", 4)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})